var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "news",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-text",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31090",
    "data-name": "Path 31090",
    d: "M15.011,21.253H7.586C4.2,21.253,2.25,19.3,2.25,15.9V6.6c0-3.4,1.949-5.35,5.336-5.35h7.425c3.388,0,5.336,1.954,5.336,5.35v9.3C20.348,19.3,18.4,21.253,15.011,21.253ZM7.586,2.646c-2.654,0-3.944,1.293-3.944,3.954v9.3c0,2.661,1.29,3.954,3.944,3.954h7.425c2.654,0,3.944-1.293,3.944-3.954V6.6c0-2.661-1.29-3.954-3.944-3.954Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31092",
    "data-name": "Path 31092",
    d: "M12,13.75H8a.75.75,0,0,1,0-1.5h4a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-1.334 -0.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31093",
    "data-name": "Path 31093",
    d: "M17.326,17.75H8.114a.757.757,0,1,1,0-1.5h9.212a.757.757,0,1,1,0,1.5Z",
    transform: "translate(-1.702 -1.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31098",
    "data-name": "Path 31098",
    d: "M5.071,5.25H3.429c-.749,0-1.179-.391-1.179-1.07V2.32c0-.679.431-1.07,1.179-1.07H5.071c.749,0,1.179.391,1.179,1.07V4.18C6.25,4.859,5.819,5.25,5.071,5.25ZM3.429,1.529c-.587,0-.872.259-.872.791V4.18c0,.532.285.791.872.791H5.071c.587,0,.872-.259.872-.791V2.32c0-.532-.285-.791-.872-.791Z",
    transform: "translate(4.049 4.268)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8708",
    "data-name": "Rectangle 8708",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNews);
export default __webpack_public_path__ + "static/media/menu-news.5aa344951f214895991b6c4dae496b5c.svg";
export { ForwardRef as ReactComponent };